// mock t function for i18next scanner to pick up
const t = (x: string) => x

export enum FilterEBKontierung {
    KeineEinschraenkung = 0,
    KeineKontierungsvorlage = 1,
    NurKontierungsvorlage = 2,
}

export const FilterEBKontierungLabels: {[k: string]: string} = {
    [FilterEBKontierung.KeineEinschraenkung]: t('ix2044:enum.FilterEBKontierung.KeineEinschraenkung'),
    [FilterEBKontierung.KeineKontierungsvorlage]: t('ix2044:enum.FilterEBKontierung.KeineKontierungsvorlage'),
    [FilterEBKontierung.NurKontierungsvorlage]: t('ix2044:enum.FilterEBKontierung.NurKontierungsvorlage'),
}

export const filterEBKontierungToOpts = (t: Function, settings: any) => {
    const opts = []

    for(let x in FilterEBKontierung) {
        if (!isNaN(Number(x))) { continue }


        opts.push({
            name: t(FilterEBKontierungLabels[FilterEBKontierung[x as keyof typeof FilterEBKontierung]]),
            value: FilterEBKontierung[x as keyof typeof FilterEBKontierung],
        })
    }

    return opts
}
